var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { ContentBaseService } from '../base/contentbase.service';
var FilterComponent = /** @class */ (function (_super) {
    __extends(FilterComponent, _super);
    function FilterComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.toggle = false;
        return _this;
    }
    FilterComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    FilterComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    FilterComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    FilterComponent.prototype.switchToggle = function () {
        this.toggle = !this.toggle;
    };
    FilterComponent.prototype.onChange = function (e) {
        this.rec[e.key] = e.val;
        this.setCompRec();
    };
    FilterComponent.prototype.setChangeCompData = function (component) {
        this.component.title = component.title;
    };
    FilterComponent.prototype.setCompRec = function () {
        this.action.setCompRec(this.componentName, this.rec);
    };
    FilterComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'filter',
                    template: "<form id=\"{{ componentName }}\">\n  <div class=\"filter\">\n    <p class=\"filter_property_heading\"><span [class.open]=\"toggle\" (click)=\"switchToggle()\">{{ component.title }}</span></p>\n    <ul class=\"filter_property_toggle -my-1 -ml-2\" [style.display]=\"toggle ? 'block': 'none'\" [comp]=\"component\" filterDir>\n      <li *ngFor=\"let col of cols; trackBy: trackByCol\" [comp]=\"component\" filterDir>\n        <column [key]=\"'forminline'\" [componentName]=\"componentName\" [col]=\"col\" [val]=\"rec\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column>\n      </li>\n    </ul>\n  </div>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    FilterComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ContentBaseService }
    ]; };
    return FilterComponent;
}(ContentBaseComponent));
export { FilterComponent };
//# sourceMappingURL=filter.component.js.map